import { INDIAN_STATES_AND_UTS, POPULAR_INDIAN_LOCATIONS } from "./indianLocations";

/** Districts per state/UT (major districts; not exhaustive). */
export const DISTRICTS_BY_STATE: Readonly<Record<string, readonly string[]>> = {
  "Andaman and Nicobar Islands": ["Nicobar", "North and Middle Andaman", "South Andaman"],
  "Andhra Pradesh": ["Anantapur", "East Godavari", "Guntur", "Krishna", "Nellore", "Visakhapatnam", "West Godavari"],
  "Arunachal Pradesh": ["East Kameng", "Itanagar Capital Complex", "Lower Subansiri", "Papum Pare", "Tawang"],
  Assam: ["Dibrugarh", "Golaghat", "Jorhat", "Kamrup Metropolitan", "Kamrup", "Sonitpur"],
  Bihar: ["Bhagalpur", "Gaya", "Muzaffarpur", "Patna", "Purnia"],
  Chandigarh: ["Chandigarh"],
  Chhattisgarh: ["Bilaspur", "Durg", "Korba", "Raipur"],
  "Dadra and Nagar Haveli and Daman and Diu": ["Dadra and Nagar Haveli", "Daman", "Diu"],
  Delhi: ["Central Delhi", "East Delhi", "New Delhi", "North Delhi", "South Delhi", "South East Delhi", "South West Delhi", "West Delhi"],
  Goa: ["North Goa", "South Goa"],
  Gujarat: ["Ahmedabad", "Gandhinagar", "Rajkot", "Surat", "Vadodara"],
  Haryana: ["Faridabad", "Gurugram", "Hisar", "Karnal", "Panipat"],
  "Himachal Pradesh": ["Kangra", "Mandi", "Shimla", "Solan"],
  "Jammu and Kashmir": ["Anantnag", "Baramulla", "Jammu", "Srinagar"],
  Jharkhand: ["Bokaro", "Dhanbad", "East Singhbhum", "Ranchi"],
  Karnataka: ["Ballari", "Belagavi", "Bengaluru Rural", "Bengaluru Urban", "Dakshina Kannada", "Mysuru", "Udupi"],
  Kerala: ["Ernakulam", "Kozhikode", "Malappuram", "Thiruvananthapuram", "Thrissur"],
  Ladakh: ["Kargil", "Leh"],
  Lakshadweep: ["Lakshadweep"],
  "Madhya Pradesh": ["Bhopal", "Gwalior", "Indore", "Jabalpur", "Ujjain"],
  Maharashtra: ["Mumbai", "Mumbai Suburban", "Nagpur", "Nashik", "Pune", "Raigad", "Thane"],
  Manipur: ["Imphal East", "Imphal West"],
  Meghalaya: ["East Khasi Hills", "West Garo Hills"],
  Mizoram: ["Aizawl"],
  Nagaland: ["Dimapur", "Kohima"],
  Odisha: ["Cuttack", "Ganjam", "Khordha", "Sundargarh"],
  Puducherry: ["Karaikal", "Mahe", "Puducherry", "Yanam"],
  Punjab: ["Amritsar", "Jalandhar", "Ludhiana", "Mohali", "Patiala"],
  Rajasthan: ["Ajmer", "Jaipur", "Jodhpur", "Kota", "Udaipur"],
  Sikkim: ["East Sikkim", "South Sikkim"],
  "Tamil Nadu": ["Chennai", "Coimbatore", "Kanchipuram", "Madurai", "Tiruchirappalli"],
  Telangana: ["Hyderabad", "Karimnagar", "Medak", "Rangareddy", "Warangal"],
  Tripura: ["Dhalai", "West Tripura"],
  "Uttar Pradesh": ["Agra", "Ghaziabad", "Kanpur Nagar", "Lucknow", "Meerut", "Noida", "Prayagraj", "Varanasi"],
  Uttarakhand: ["Dehradun", "Haridwar", "Nainital", "Udham Singh Nagar"],
  "West Bengal": ["Darjeeling", "Hooghly", "Howrah", "Kolkata", "North 24 Parganas", "South 24 Parganas"],
};

/** Cities commonly used per state (merged with popular list at runtime). */
export const CITIES_BY_STATE: Readonly<Record<string, readonly string[]>> = {
  "Andaman and Nicobar Islands": ["Port Blair"],
  "Andhra Pradesh": ["Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Tirupati"],
  "Arunachal Pradesh": ["Itanagar", "Tawang"],
  Assam: ["Guwahati", "Dibrugarh", "Silchar", "Jorhat"],
  Bihar: ["Patna", "Gaya", "Muzaffarpur", "Bhagalpur"],
  Chandigarh: ["Chandigarh"],
  Chhattisgarh: ["Raipur", "Bhilai", "Bilaspur"],
  "Dadra and Nagar Haveli and Daman and Diu": ["Silvassa", "Daman", "Diu"],
  Delhi: ["Delhi", "New Delhi"],
  Goa: ["Panaji", "Margao", "Vasco da Gama", "Goa"],
  Gujarat: ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Gandhinagar"],
  Haryana: ["Gurugram", "Faridabad", "Panipat", "Ambala"],
  "Himachal Pradesh": ["Shimla", "Manali", "Dharamshala"],
  "Jammu and Kashmir": ["Srinagar", "Jammu"],
  Jharkhand: ["Ranchi", "Jamshedpur", "Dhanbad"],
  Karnataka: ["Bengaluru", "Mysuru", "Mangaluru", "Hubballi"],
  Kerala: ["Kochi", "Thiruvananthapuram", "Kozhikode", "Thrissur"],
  Ladakh: ["Leh", "Kargil"],
  Lakshadweep: ["Kavaratti"],
  "Madhya Pradesh": ["Bhopal", "Indore", "Gwalior", "Jabalpur", "Ujjain"],
  Maharashtra: ["Mumbai", "Pune", "Nagpur", "Nashik", "Thane", "Navi Mumbai", "Aurangabad"],
  Manipur: ["Imphal"],
  Meghalaya: ["Shillong"],
  Mizoram: ["Aizawl"],
  Nagaland: ["Kohima", "Dimapur"],
  Odisha: ["Bhubaneswar", "Cuttack", "Rourkela"],
  Puducherry: ["Puducherry"],
  Punjab: ["Ludhiana", "Amritsar", "Jalandhar", "Mohali", "Patiala"],
  Rajasthan: ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer"],
  Sikkim: ["Gangtok"],
  "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem"],
  Telangana: ["Hyderabad", "Warangal", "Karimnagar"],
  Tripura: ["Agartala"],
  "Uttar Pradesh": ["Lucknow", "Kanpur", "Noida", "Ghaziabad", "Agra", "Varanasi", "Prayagraj", "Meerut"],
  Uttarakhand: ["Dehradun", "Haridwar", "Rishikesh", "Nainital"],
  "West Bengal": ["Kolkata", "Howrah", "Durgapur", "Siliguri", "Asansol"],
};

/** Expected state for a city name (metros and aliases). */
export const CITY_STATE_HINTS: Readonly<Record<string, string>> = {
  Mumbai: "Maharashtra",
  "Navi Mumbai": "Maharashtra",
  Pune: "Maharashtra",
  Nagpur: "Maharashtra",
  Nashik: "Maharashtra",
  Thane: "Maharashtra",
  Delhi: "Delhi",
  "New Delhi": "Delhi",
  Bengaluru: "Karnataka",
  Mysuru: "Karnataka",
  Mangaluru: "Karnataka",
  Hyderabad: "Telangana",
  Chennai: "Tamil Nadu",
  Coimbatore: "Tamil Nadu",
  Madurai: "Tamil Nadu",
  Kolkata: "West Bengal",
  Ahmedabad: "Gujarat",
  Surat: "Gujarat",
  Jaipur: "Rajasthan",
  Goa: "Goa",
  Panaji: "Goa",
  Chandigarh: "Chandigarh",
  Lucknow: "Uttar Pradesh",
  Kochi: "Kerala",
  Indore: "Madhya Pradesh",
  Bhopal: "Madhya Pradesh",
  Noida: "Uttar Pradesh",
  Gurugram: "Haryana",
  Faridabad: "Haryana",
  Visakhapatnam: "Andhra Pradesh",
  Vijayawada: "Andhra Pradesh",
  Guwahati: "Assam",
  Patna: "Bihar",
  Bhubaneswar: "Odisha",
  Ranchi: "Jharkhand",
  Srinagar: "Jammu and Kashmir",
  Shimla: "Himachal Pradesh",
  Dehradun: "Uttarakhand",
};

const STATE_SET = new Set<string>(INDIAN_STATES_AND_UTS);

export function isValidIndianState(state: string): boolean {
  return STATE_SET.has(state.trim());
}

export function getDistrictsForState(state: string): string[] {
  const key = state.trim();
  if (!key) return [];
  return [...(DISTRICTS_BY_STATE[key] ?? [])].sort((a, b) => a.localeCompare(b));
}

export function getCitiesForState(state: string): string[] {
  const key = state.trim();
  if (!key) return [];
  const fromState = CITIES_BY_STATE[key] ?? [];
  const popularInState = POPULAR_INDIAN_LOCATIONS.filter((city) => {
    const hint = CITY_STATE_HINTS[city] ?? expectedStateForCity(city);
    return hint === key;
  });
  const merged = new Set<string>([...popularInState, ...fromState]);
  return Array.from(merged).sort((a, b) => a.localeCompare(b));
}

export function expectedStateForCity(city: string): string | null {
  const trimmed = city.trim();
  if (!trimmed) return null;
  if (CITY_STATE_HINTS[trimmed]) return CITY_STATE_HINTS[trimmed];
  for (const [state, cities] of Object.entries(CITIES_BY_STATE)) {
    if (cities.some((c) => c.toLowerCase() === trimmed.toLowerCase())) return state;
  }
  return null;
}

export function isDistrictValidForState(district: string, state: string): boolean {
  const d = district.trim();
  const s = state.trim();
  if (!d || !s) return true;
  const known = DISTRICTS_BY_STATE[s];
  if (!known || known.length === 0) return true;
  return known.some((item) => item.toLowerCase() === d.toLowerCase());
}

export function isCityValidForState(city: string, state: string): boolean {
  const c = city.trim();
  const s = state.trim();
  if (!c || !s) return true;
  const hint = expectedStateForCity(c);
  if (hint && hint !== s) return false;
  const stateCities = getCitiesForState(s);
  if (stateCities.some((item) => item.toLowerCase() === c.toLowerCase())) return true;
  return !hint;
}
